const ErrorIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <rect width="32" height="32" fill="#DB3641" rx="16"></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 10L10 22m0-12l12 12"
      ></path>
    </svg>
  )
}

export default ErrorIcon
